import { graphConfig } from "./authConfig";
import axios from 'axios';

/**
 * Attaches a given access token to a MS Graph API call. Returns information about the user
 * @param accessToken 
 */
/**
 * Calls the Microsoft Graph API using the provided access token.
 * @param {string} accessToken - The access token for authentication.
 * @returns {Promise<Object>} - A promise that resolves to the response JSON object.
 */
export async function callMsGraph(accessToken) {
    const bearer = `Bearer ${accessToken}`;

    const options = {
        method: "GET",
        headers: {
            "Authorization": bearer
        }
    };

    try {
        const response = await axios.get(graphConfig.graphMeEndpoint, options);
        return response.data;
    } catch (error) {
        console.log(error);
        return error;
    }
}